export function isInactiveWorkspaceMembership(membership) {
    return ["restricted", "removed"].includes(String(membership?.memberShipStatus || ""));
}

export function nextWorkspaceMembershipStatus(membership) {
    return isInactiveWorkspaceMembership(membership) ? "joined" : "restricted";
}
